/// <reference path="../typings/index.d.ts" />

namespace App.Docs {
  /**
   * Menu de usuário na docs. O Bootstrap/Popper aplica left/transform inline no #dropdownMenuNome,
   * o que corta o menu em telas menores — aqui reposicionamos com base na viewport.
   */
  export class UserMenu {
    private static readonly VIEWPORT_PADDING = 8;

    public static inicializar(): void {
      const $dropdown = $('.docs-topbar-user .dropdown');

      if (!$dropdown.length) {
        return;
      }

      const $toggle = $dropdown.find('[data-toggle="dropdown"]');
      const $menu = $dropdown.find('#dropdownMenuNome');

      $menu.addClass('dropdown-menu-right');

      $dropdown.on('shown.bs.dropdown', function () {
        UserMenu.posicionarMenu($toggle, $menu);
      });

      $dropdown.on('hidden.bs.dropdown', function () {
        UserMenu.limparPosicionamento($(this).find('.dropdown-menu'));
      });

      $(window).on('resize.docsUserMenu', function () {
        if ($dropdown.hasClass('show')) {
          UserMenu.posicionarMenu($toggle, $menu);
        }
      });
    }

    private static posicionarMenu($toggle: JQuery, $menu: JQuery): void {
      const toggleEl = $toggle[0] as HTMLElement;
      const menuEl = $menu[0] as HTMLElement;

      if (!toggleEl || !menuEl) {
        return;
      }

      const toggleRect = toggleEl.getBoundingClientRect();
      const menuWidth = menuEl.offsetWidth;
      const menuHeight = menuEl.offsetHeight;
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const padding = UserMenu.VIEWPORT_PADDING;

      let left = toggleRect.right - menuWidth;
      left = Math.max(padding, Math.min(left, viewportWidth - menuWidth - padding));

      let top = toggleRect.bottom;

      if (top + menuHeight > viewportHeight - padding) {
        top = Math.max(padding, viewportHeight - menuHeight - padding);
      }

      $menu.css({
        position: 'fixed',
        top: top + 'px',
        left: left + 'px',
        right: 'auto',
        transform: 'none',
        willChange: 'auto',
      });
    }

    private static limparPosicionamento($menu: JQuery): void {
      $menu.css({
        position: '',
        top: '',
        left: '',
        right: '',
        transform: '',
        willChange: '',
      });
    }
  }
}
